import Alpine from 'alpinejs'

window.Alpine = Alpine

const conjuredForm = (options, formData) => {
    options = options ?? {};
    formData = formData ?? {};
    return {
        formEl: null,
        init() {
            this.$nextTick(() => {
                this.formEl = this.$el;
                this.genericError = this.formEl.querySelector('[x-bind="errorText"]').textContent;
            })
        },
        submitForm: {
            ['x-bind:disabled']() {
                return this.loading;
            },
            ['@click.prevent']() {
                return this.submit();
            }
        },
        successText: {
            ['x-show']() {
                return this.success;
            }
        },
        errorText: {
            ['x-show']() {
                return this.error;
            }
        },
        success: false,
        genericError: '',
        error: false,
        loading: false,
        method: 'POST',
        data: {
            ...formData
        },
        url: '',
        onSuccess(response) {
        },
        onError(response) {
        },
        finally(response) {
        },
        submit() {
            const self = this;
            this.loading = true;
            this.success = false;
            this.error = false;
            return fetch(this.url, {
                method: this.method,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    ...this.$data.conjuredFormData,
                    ...this.data
                })
            }).then((response) => {
                console.log(response);
                if (response.status === 200 || response.status === 201) {
                    self.success = true;
                    self.onSuccess(response);
                } else if (response.status === 422) {
                    response.json().then(data => {
                        let messages = Object.values(data.errors);
                        let errRoot = self.formEl.querySelector('[x-bind="errorText"]');
                        let errEl = errRoot.querySelector('span') || errRoot;

                        if (errEl) {
                            errEl.innerHTML = messages && messages.length ? messages.map(msg => {
                                return msg[0];
                            }).join('. ') : this.genericError;
                        }

                    self.error = true;
                    })

                    self.onError(response);
                }
            }).catch((error) => {
                console.log(error);
                this.error = error;
                this.onError(error);
            }).finally((response) => {
                console.log(response);
                this.loading = false;
                this.finally(response);
            })
        },
        ...options
    };
};
Alpine.data('form', conjuredForm);
Alpine.data('conjuredMembership', (membershipId) => {
    return {
        membershipId: membershipId,
        //
        // More plans
        //
        showMorePlans: false,
        showUpdatePlan: {
            ['x-on:click']() {
                this.showMorePlans = true;
            }
        },
        hideUpdatePlan: {
            ['x-on:click']() {
                this.showMorePlans = false;
            }
        },
        updatePlanContent: {
            ['x-transition']: null,
            ['x-on:click.outside']() {
                this.showMorePlans = false;
            },
            ['x-show']() {
                return this.showMorePlans;
            }
        },
        updatePlanForm: {
            ['x-data']() {
                const self = this;

                return {
                    ...conjuredForm({
                        method: 'PUT',
                        url: this.$data.secureUrl + '/a/membership/memberships/' + this.membershipId,
                        onSuccess(response) {
                            window.location.reload();
                        }
                    }, {
                        shopify_membership_type_option_id: this.$data.selectedMembershipTypeOptions[self.membershipId]
                    }),
                    variant_id: this.$data.selectedVariants[self.membershipId],
                    selectVariant: {
                        ['x-model']: 'variant_id'
                    },
                    selectPlan: {
                        ['x-model']: 'data.shopify_membership_type_option_id'
                    },
                    selectPlanOption: {
                        ['x-bind:value']: 'key',
                        ['x-text']: 'name',
                        ['x-bind:selected']: "key === data.shopify_membership_type_option_id"
                    },
                    selectVariantOption: {
                        ['x-bind:value']: 'key',
                        ['x-text']: 'name',
                        ['x-bind:selected']: "key === variant_id"
                    },
                    get plans() {
                        return this.$data.membershipPlans[self.membershipId];
                    },
                    get variants() {
                        return this.plans.reduce((plans, plan) => {
                            plans[plan.variant_id] = plan.name;
                            return plans;
                        }, {});
                    },
                    get paymentPlans() {
                        let variants = this.plans.reduce((plans, plan) => {
                            if (plan.variant_id == this.variant_id) {
                                plans[plan.id] = plan.interval_count > 1 ?
                                    plan.price + ' / ' + plan.interval_count + ' ' + plan.interval :
                                    plan.price + ' / ' + plan.interval;
                            }
                            return plans;
                        }, {});

                        if (!(this.data.shopify_membership_type_option_id in variants)) {
                            this.data.shopify_membership_type_option_id = Object.keys(variants)[0];
                        }

                        return variants;
                    }
                };
            }
        },
        //
        // Cancel
        //
        showCancelModal: false,
        showCancel: {
            ['x-on:click']() {
                this.showCancelModal = true;
            }
        },
        cancelContent: {
            ['x-transition']: null,
            ['x-on:click.outside']() {
                this.showCancelModal = false;
            },
            ['x-show']() {
                return this.showCancelModal;
            }
        },
        hideCancel: {
            ['x-on:click']() {
                this.showCancelModal = false;
            }
        },
        cancelModal: {
            ['x-on:click.outside']() {
                this.showCancelModal = false;
            },
            ['x-show']() {
                return this.showCancelModal;
            }
        },
        cancelForm: {
            ['x-data']() {
                return conjuredForm({
                    method: 'PUT',
                    url: this.$data.secureUrl + '/a/membership/memberships/' + this.membershipId,
                    onSuccess(response) {
                        window.location.reload();
                    }
                }, {
                    status: 'cancelled',
                    reason: null
                })
            }
        },
        selectCancelReason: {
            ['x-model']: 'data.reason'
        },
        //
        // Activate
        //
        showReactivateModal: false,
        showActivate: {
            ['x-on:click']() {
                this.showReactivateModal = true;
            }
        },
        hideActivate: {
            ['x-on:click']() {
                this.showReactivateModal = false;
            }
        },
        activateContent: {
            ['x-transition']: null,
            ['x-on:click.outside']() {
                this.showReactivateModal = false;
            },
            ['x-show']() {
                return this.showReactivateModal;
            }
        },
        activateForm: {
            ['x-data']() {
                return conjuredForm({
                    method: 'PUT',
                    url: this.$data.secureUrl + '/a/membership/memberships/' + this.membershipId,
                    onSuccess(response) {
                        window.location.reload();
                    }
                }, {
                    status: 'active'
                })
            }
        },
        //
        // Update Payment Method
        //
        showUpdatePaymentMethod: false,
        showUpdatePayment: {
            ['x-on:click']() {
                this.showUpdatePaymentMethod = true;
            }
        },
        hideUpdatePayment: {
            ['x-on:click']() {
                this.showUpdatePaymentMethod = false;
            }
        },
        updatePaymentContent: {
            ['x-transition']: null,
            ['x-on:click.outside']() {
                this.showUpdatePaymentMethod = false;
            },
            ['x-show']() {
                return this.showUpdatePaymentMethod;
            }
        },
        updatePaymentForm: {
            ['x-data']() {
                return conjuredForm({
                    url: this.$data.secureUrl + '/a/membership/memberships/' + this.membershipId + '/send'
                })
            }
        },
    };
});

Alpine.start()